const options = {
	method: 'GET',
	headers: {
		'Accept-Language': 'de',
		accept: 'application/json',
	},
};
class ReviewsIoCarousel extends HTMLElement {
	async connectedCallback() {
		this.data = await fetch(
			`https://api.reviews.co.uk/reviews?store=${this.store}&sku=${this.sku}&per_page=${this.reviewsCount * 5}${
				this.tags
			}&type=product_review`,
			options,
		)
			.then((response) => response.json())
			.catch((error) => {
				this.parentNode.hidden = true;
			});
		this.initStarsEvent();
		this.render();
	}
	get store() {
		return this.getAttribute('store');
	}
	get sku() {
		return this.getAttribute('sku');
	}
	get tags() {
		return this.getAttribute('tags') ? `&tag=${this.getAttribute('tags')}` : '';
	}
	get reviewsCount() {
		return parseInt(this.getAttribute('reviews-count'));
	}
	get anchorToPdpReviewsWidget() {
		return this.getAttribute('anchor-to-pdp-reviews-widget') === 'true';
	}
	get minReviewPercent() {
		return parseInt(this.getAttribute('min-review-percent'));
	}
	initStarsEvent() {
		setTimeout(() => {
			// should be linked to the reviews widget which is available from the reviews.io app
			// document.querySelector('.ruk_rating_snippet')?.addEventListener('click', this.onStarsClick.bind(this));
			if (this.anchorToPdpReviewsWidget) {
				this.querySelector('.reviews-io-store__stats')?.addEventListener('click', () => {
					document
						.querySelector('reviewsio-product-reviews-widget,#reviewsio-product-reviews-widget > div')
						?.scrollIntoView({ behavior: 'smooth' });
				});
			}
		}, 1500);
	}
	onStarsClick(event) {
		const toScroll = this.parentNode.firstChild;
		toScroll.scrollIntoView({ behavior: 'smooth' });
	}
	render() {
		if (!this.data) {
			return;
		}
		this.alreadyAddedReviewer = [];
		const storeRating = parseFloat(this.data.average_rating);
		const storeCount = this.data.review_count;
		this.updateStoreStats(storeRating, storeCount);
		this.reviewsItems = this.data.reviews
			.filter((review) => review.rating >= this.minReviewPercent && review.comments.length > 10)
			.map((review) => {
				const author = review.author.name;

				if (this.alreadyAddedReviewer.includes(author) || author == 'Anonym') {
					return null;
				}
				this.alreadyAddedReviewer.push(author);
				let location = review.author.location || '';
				location = location.replace(/"/g, '');
				// remove 'Germany' or ', Germany' from location
				location = location.replace(/,?\s?(?:IT|Italy)\b/gi, '');
				const timeAgo = this.generateTimeAgo(review.date_created);
				//const timeAgoAndLocation = location !== '' ? `${location}, ${timeAgo}` : timeAgo;
				const timeAgoAndLocation = timeAgo;
				return this.generateReviewNodes({
					author,
					rating: review.rating,
					body: review.comments,
					timeAgoAndLocation: timeAgoAndLocation,
					date: this.formatDate(review.date_created),
				});
			})
			.filter((review) => review !== null);

		this.reviewsWrapper = this.querySelector('[data-review-list]');
		this.reviewsWrapper.innerHTML = '';
		this.reviewsItems.slice(0, this.reviewsCount).forEach((review) => {
			this.reviewsWrapper.appendChild(review);
		});
		this.carousel = this.querySelector('scroll-carousel');
		const newCarousel = this.carousel.cloneNode(true);
		this.carousel.replaceWith(newCarousel);
		this.pageDots = this.querySelector('page-dots');
		if (this.pageDots) {
			// Remove dots if there are less reviews than the reviews count
			Array.from(this.pageDots.children).forEach((dot, index) => {
				if (index >= this.reviewsCount) {
					dot.remove();
				}
			});
		}
	}
	async updateStoreStats(stars, count) {
		if (this.tags) {
			this.storeData = await fetch(
				`https://api.reviews.co.uk/reviews?store=${this.store}&sku=${this.sku}&per_page=0`,
				options,
			)
				.then((response) => response.json())
				.catch((error) => {
					console.error('Error:', error);
				});
			this.stars = parseFloat(this.storeData.average_rating);
			this.count = this.storeData.review_count;
		} else {
			this.stars = stars;
			this.count = count;
		}
		this.storeStars = this.querySelector('[data-store-stars]');
		this.storeAverage = this.querySelector('[data-store-average]');

		this.storeCount = this.querySelector('[data-store-count]');
		if (this.storeStars && this.storeAverage && this.storeCount) {
			this.storeStars.innerHTML = this.generateStarIcons(this.stars);
			const decimal = parseInt(this.storeAverage.getAttribute('data-store-average')) || 2;
			this.storeAverage.innerHTML = this.stars.toFixed(decimal).replace('.', ',');
			this.storeCount.innerHTML = this.formatNumber(this.count);
		}
	}
	formatNumber(number) {
		return new Intl.NumberFormat('de-DE').format(number);
	}
	generateStarIcons(rating) {
		if (!window.themeVariables || !window.themeVariables.svgs) {
			console.error('[ReviewsIoCarousel] window.themeVariables.svgs is not defined!');
			return '';
		}

		const { fullStar, halfStar, emptyStar } = window.themeVariables.svgs;

		let filledStars = '';
		let emptyStars = '';
		let fullStars = Math.floor(rating);
		let partialStar = rating - fullStars;

		filledStars = fullStar.repeat(fullStars);

		if (partialStar > 0) {
			if (partialStar <= 0.7) {
				filledStars += halfStar;
			} else {
				filledStars += fullStar;
			}
			fullStars += 1;
		}

		emptyStars = emptyStar.repeat(5 - fullStars);

		return filledStars + emptyStars;
	}
	generateReviewNodes(review) {
		const reviewNode = this.querySelector('[data-review-item]').cloneNode(true);
		const author = reviewNode.querySelector('[data-review-item-author]');
		const rating = reviewNode.querySelector('[data-review-item-rating]');
		const body = reviewNode.querySelector('[data-review-item-body]');
		const date = reviewNode.querySelector('[data-review-item-date]');
		const showDate = date.getAttribute('data-review-item-date') === 'true';
		const shortAuthor = author.getAttribute('data-review-item-author') === 'short';
		author.innerHTML = shortAuthor ? this.shortenAuthorName(review.author) : review.author;
		rating.innerHTML = this.generateStarIcons(review.rating);
		body.innerHTML = review.body;
		date.innerHTML = showDate ? review.date : review.timeAgoAndLocation;
		return reviewNode;
	}
	shortenAuthorName(name) {
		const [firstName, lastName] = name.split(' ');
		return lastName ? `${firstName[0]}. ${lastName}` : firstName;
	}
	formatDate(date) {
		const dateObj = new Date(date);
		const day = dateObj.getDate();
		const month = dateObj.getMonth() + 1;
		const year = dateObj.getFullYear();
		return `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`;
	}
	generateTimeAgo(dateString) {
		const date = new Date(dateString);
		const now = new Date();

		const seconds = Math.floor((now - date) / 1000);
		const minutes = Math.floor(seconds / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);
		const weeks = Math.floor(days / 7);
		const months = Math.floor(days / 30);
		const years = Math.floor(months / 12);

        if (years > 0) {
            return years === 1 ? '1 anno fa' : years + ' anni fa';
        } else if (months > 0) {
            return months === 1 ? '1 mese fa' : months + ' mesi fa';
        } else if (weeks > 0) {
            return weeks === 1 ? '1 settimana fa' : weeks + ' settimane fa';
        } else if (days > 0) {
            return days === 1 ? '1 giorno fa' : days + ' giorni fa';
        } else if (hours > 0) {
            return hours === 1 ? '1 ora fa' : hours + ' ore fa';
        } else if (minutes > 0) {
            return minutes === 1 ? '1 minuto fa' : minutes + ' minuti fa';
        } else {
            return seconds === 1 ? '1 secondo fa' : seconds + ' secondi fa';
        }
	}
}

if (!window.customElements.get('reviews-io-carousel')) {
	window.customElements.define('reviews-io-carousel', ReviewsIoCarousel);
}

class ReviewsIoCustomProductRatingWidget extends HTMLElement {
	async connectedCallback() {
		const options = {method: 'GET', headers: {accept: 'application/json'}};
		this.storeData = await fetch(
			`https://api.reviews.co.uk/reviews?store=${this.store}&sku=${this.sku}&per_page=0&type=product_review`,
			options,
		)
			.then((response) => response.json())
			.then((response) => this.render(response))
			.catch((error) => {
				console.error('Error:', error);
			});
		if(this.hasAttribute('linked-to-reviews')) {
			this.initStarsEvent()
		}
	}

	get store() {
		return this.getAttribute('store');
	}
	get sku() {
		return this.getAttribute('sku');
	}

	render(storeData) {
		this.stars = parseFloat(storeData.average_rating);
		this.count = storeData.review_count;
		this.storeStars = this.querySelector('[data-store-stars]');
		this.storeAverage = this.querySelector('[data-store-average]');
		this.storeCount = this.querySelector('[data-store-count]');
		if (this.storeStars && this.storeAverage && this.storeCount) {
			this.storeAverage.innerHTML = this.stars.toFixed(1);
			this.storeCount.innerHTML = this.count;
			this.storeStars.innerHTML = this.generateStarIcons(this.stars);
		}
	}

	generateStarIcons(rating) {
		if (!window.themeVariables || !window.themeVariables.svgs) {
			console.error('[ReviewsIoCustomProductRatingWidget] window.themeVariables.svgs is not defined!');
			return '';
		}

		const { fullStar, halfStar, emptyStar } = window.themeVariables.svgs;

		let filledStars = '';
		let emptyStars = '';
		let fullStars = Math.floor(rating);
		let partialStar = rating - fullStars;

		filledStars = fullStar.repeat(fullStars);

		if (partialStar > 0) {
			if (partialStar <= 0.7) {
				filledStars += halfStar;
			} else {
				filledStars += fullStar;
			}
			fullStars += 1;
		}

		emptyStars = emptyStar.repeat(5 - fullStars);

		return filledStars + emptyStars;
	}

	initStarsEvent() {
		setTimeout(() => {
				this.addEventListener('click', () => {
					document
						.querySelector('reviewsio-product-reviews-widget,#reviewsio-product-reviews-widget > div')
						?.scrollIntoView({ behavior: 'smooth' });
				});
		}, 1500);
	}
}



if (!window.customElements.get('reviews-io-custom-product-rating-widget')) {
	window.customElements.define('reviews-io-custom-product-rating-widget', ReviewsIoCustomProductRatingWidget);
}
